var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoToToday(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2045 10.75L13.9318 13.4773L11.2045 16.2045M7.11364 10.75L9.84091 13.4773L7.11364 16.2045M0.75 6.20455H20.75M2.56818 20.75H18.9318C19.414 20.75 19.8765 20.5584 20.2175 20.2175C20.5584 19.8765 20.75 19.414 20.75 18.9318V2.56818C20.75 2.08597 20.5584 1.62351 20.2175 1.28253C19.8765 0.941558 19.414 0.75 18.9318 0.75H2.56818C2.08597 0.75 1.62351 0.941558 1.28253 1.28253C0.941558 1.62351 0.75 2.08597 0.75 2.56818V18.9318C0.75 19.414 0.941558 19.8765 1.28253 20.2175C1.62351 20.5584 2.08597 20.75 2.56818 20.75Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToToday);
export default __webpack_public_path__ + "static/media/go-to-today.ac8a88ed3025edb5550e0f4faba47e3a.svg";
export { ForwardRef as ReactComponent };